import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import P2 from '@base/P2/P2';
import H6 from '@base/H6/H6';
import { breakpoints, Spacings } from '@styles/index';

const AuthorPropertiesWrapper = styled.div`
  flex-direction: column;
  display: flex;
  :first-child {
    margin-right: ${Spacings.SPACING_6B};
  }
`;

const Stats = styled(H6)`
  @media only screen and (max-width: ${breakpoints.mobile}) {
    font-size: 14px;
    margin-bottom: 2px;
  }
`;

const EducatorProperties = ({ stats, label }) => {
  return (
    <AuthorPropertiesWrapper>
      <Stats color="var(--color-text-primary)">{stats}</Stats>
      <P2 color="var(--color-text-secondary)">{label}</P2>
    </AuthorPropertiesWrapper>
  );
};

EducatorProperties.propTypes = {
  stats: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired
};

export default EducatorProperties;
